import { memo } from 'react';

export const Globe = memo(() => {
  return (
    <div className='sm:hidden md:min-w-win right-0 md:h-full h-0 sticky top-0'>
      <iframe className='h-full w-full' src='../../hologram/globe.html' title='description'></iframe>
    </div>
  );
});
